/* global axios */
import ApiClient from '../ApiClient';

class AgnoKnowledgeAPI extends ApiClient {
  constructor() {
    super('agno/knowledge_items', { accountScoped: true });
  }

  // Lista itens visíveis pra um agente (globais + atribuídos a ele).
  // reviewState filtra por review_state ('active' | 'needs_review').
  getForAgent(agentId, reviewState) {
    const params = {};
    if (agentId) params.agent_id = agentId;
    if (reviewState) params.review_state = reviewState;
    return axios.get(this.url, { params });
  }

  // Confirma um item migrado do acervo legado (needs_review -> active).
  confirm(id) {
    return axios.post(`${this.url}/${id}/confirm`);
  }

  // Desfaz confirmação (inclusive automática): item volta para "A revisar".
  unconfirm(id) {
    return axios.post(`${this.url}/${id}/unconfirm`);
  }

  // Edita título/conteúdo de um candidato aprendido antes de confirmar.
  updateContent(id, { title, content, ...facts }) {
    return axios.patch(`${this.url}/${id}`, { title, content, ...facts });
  }

  // Cria item de texto OU arquivo (FormData). agentIds=[] => global.
  createItem({ title, content, file, agentIds = [], facts = {} }) {
    const form = new FormData();
    form.append('title', title);
    Object.entries(facts).forEach(([key, value]) =>
      form.append(key, value || '')
    );
    (agentIds || []).forEach(id => form.append('agent_ids[]', id));
    if (file) {
      const ext = (file.name.split('.').pop() || '').toLowerCase();
      const type = ['pdf', 'txt', 'docx'].includes(ext) ? ext : 'txt';
      form.append('source_type', type);
      form.append('file', file);
    } else {
      form.append('source_type', 'text');
      form.append('content', content);
    }
    return axios.post(this.url, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  // Reatribui o escopo do item (lista de agentes; vazia = global).
  updateScope(id, agentIds) {
    return axios.patch(`${this.url}/${id}`, { agent_ids: agentIds });
  }

  // Métricas do cérebro de aprendizado da conta (faixa no topo da aba Conhecimento).
  stats() {
    return axios.get(`${this.url}/stats`);
  }
}

export default new AgnoKnowledgeAPI();
